export { default } from "./close.svg";
